import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MonthNavigator = ({ currentMonth, onNavigate, onToday }) => {
  const formatMonthYear = () => {
    return currentMonth?.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
  };

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 px-4 md:px-6 lg:px-8 py-4 md:py-5 lg:py-6 bg-card border-b border-border">
      <div>
        <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-semibold text-foreground">
          {formatMonthYear()}
        </h2>
        <p className="text-xs md:text-sm lg:text-base text-muted-foreground mt-1">
          Month view • All appointments
        </p>
      </div>
      
      <div className="flex items-center gap-2 md:gap-3">
        <Button
          variant="outline"
          size="default"
          iconName="Calendar"
          iconPosition="left"
          onClick={onToday}
          className="text-sm md:text-base"
        >
          Today
        </Button>
        
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="icon"
            onClick={() => onNavigate(-1)}
            aria-label="Previous month"
          >
            <Icon name="ChevronLeft" size={20} />
          </Button>
          <Button
            variant="outline"
            size="icon"
            onClick={() => onNavigate(1)}
            aria-label="Next month"
          >
            <Icon name="ChevronRight" size={20} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MonthNavigator;